import { useLocation } from '@okapi/router-react';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { useRegionIdSelector } from 'modules/model-json/model-json-selectors';
import { getLang } from 'utils/get-lang-from-url';

const isHrefConvertable = (href: string | undefined) => (
  href && !href?.startsWith('/kz') && href?.startsWith('/')
);

export const useHrefConverter = (href: string | undefined) => {
  const regionId = useRegionIdSelector();
  const [path] = useLocation();
  const lang = getLang(path);

  if (lang === 'ru') {
    return href;
  }

  if (regionId === KAZAKHSTAN && isHrefConvertable(href)) {
    return `/kz${href}`;
  }

  return href;
}